var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{staticClass:"wow bounceInDown"}),_c('router-view'),_c('ComFooter',{staticClass:"wow bounceInUp"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }